
define(
	'NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent'
,   [
		'NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent.View'
	]
,   function (
		OutstandingPaymentAndEventView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */

			var layout = container.getComponent('Layout');
			var pdp =  container.getComponent('PDP');
			var itemDetail = pdp.getItemInfo();
			if(layout)
			{
				layout.addChildView('OutstandingPaymentAndEventView', function() { 
					return new OutstandingPaymentAndEventView({ container: container,pdp: pdp.getItemInfo() });
				});
			}


		}
	};
});
